import React, { useState, useEffect, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import style from './CatalogPreviewModal.module.scss';
import Modal from 'react-bootstrap/Modal';
import CatalogPreview from './CatalogPreview';
import { useCatalogItemListener } from './UseCatalogItemListener';
export const CatalogPreviewModal = (props) => {
    const [open, setOpen] = useState(false);
    const { catalog } = useCatalogItemListener();
    const { t } = useTranslation(['catalog']);
    const onModalClose = () => {
        setOpen(false);
    };
    useEffect(() => {
        if (catalog) {
            setOpen(true);
        }
    }, [catalog]);
    return (React.createElement(Modal, { show: open, onHide: onModalClose, className: "modal-catalog-preview fade", dialogClassName: style.CatalogPreviewModal, size: 'lg', centered: true },
        React.createElement(Modal.Header, { closeButton: true },
            React.createElement(Modal.Title, null, t('catalog.preview.title'))),
        React.createElement(Modal.Body, null,
            React.createElement(CatalogPreview, { catalog: catalog })),
        React.createElement(Modal.Footer, { className: "justify-content-center" },
            React.createElement("button", { type: "button", onClick: onModalClose, className: "btn btn-outline-primary", "data-dismiss": "modal", "aria-label": "Close" }, t('close')))));
};
export const renderCatalogPreviewModal = () => {
    let modalId = 'aperza-catalog-preview-modal';
    let modal = document.getElementById(modalId);
    if (!modal) {
        let aperzaCatalogPreviewModal = document.createElement('div');
        aperzaCatalogPreviewModal.id = modalId;
        document.body.appendChild(aperzaCatalogPreviewModal);
        ReactDOM.render(React.createElement(Suspense, { fallback: React.createElement("div", null) },
            React.createElement(CatalogPreviewModal, null)), aperzaCatalogPreviewModal);
    }
    else {
        console.warn(`Trying to create additional modal: ${modalId}`);
    }
};
